import PropTypes from 'prop-types';
import React from 'react';

const TextAreaInput = ({ disabled, error, label, name, onChange, placeholder, rows = 3, value }) => {
    let wrapperClass = 'form-group';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            {label ? <h5 htmlFor={name}>{label}</h5> : ''}
            <div className="field">
                <textarea
                    disabled={disabled}
                    rows={rows}
                    name={name}
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange} />
                {error && <div className="alert alert-danger">{error}</div>}
            </div>
        </div>
    );
};

TextAreaInput.propTypes = {
    disabled: PropTypes.string,
    rows: PropTypes.number,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string
};

export default TextAreaInput;
